<template>
  <div @click="$emit('openBoostModel')">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline"> Boost </span>
          <v-spacer></v-spacer>
          <v-icon @click="$emit('openBoostModel')">close</v-icon>
        </v-card-title>
        <v-tabs grow="grow">
          <v-tab ripple>
            Create Boost
          </v-tab>
          <v-tab ripple>
            Show Boost
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-list three-line subheader>
                <v-col>
                  <v-text-field
                    label="Tier"
                    disabled
                    v-model="data.tier_prize_id"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="data.start_date"
                        label="Start date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data.start_date"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="data.end_date"
                        label="End date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data.end_date"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="data.start_time"
                        label="Start Time"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="data.start_time"
                      type="month"
                      width="290"
                      class="ml-4"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="data.end_time"
                        label="End Time"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="data.end_time"
                      type="month"
                      width="290"
                      class="ml-4"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col>
                   <v-select
                    :items="items"
                    v-model="data.recurring"
                    label="recurring"
                    ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    type="number"
                    label="weight"
                    required
                    v-model="data.weight"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    type="number"
                    label="total_allotted"
                    required
                    v-model="data.total_allotted"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    type="number"
                    label="remaining_allotted"
                    required
                    v-model="data.remaining_allotted"
                  ></v-text-field>
                </v-col>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item tab-item>
            <v-card flat>
               <v-data-table
                  :headers="headers"
                  :items="boostData"
                  :items-per-page="10"
                  class="elevation-1"
                ></v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="$emit('openBoostModel')"
            >Close</v-btn
          >
          <v-btn color="darken-1" class="primary" text @click="createBoost()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/clients/prizingapi/boost'
import header from './boostTableColumns'

export default {
  props: ['title', 'btnTitle', 'item', 'deleteModal'],
  data: () => ({
    items: ['daily', 'weekly', 'monthly', 'yearly'],
    dialog: true,
    headers: header,
    boostData: [],
    data: {
      tier_prize_id: '',
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      recurring: '',
      weight: 0,
      total_allotted: 0,
      remaining_allotted: 0
    }
  }),
  mounted () {
    this.data.tier_prize_id = this.item.id
    this.getBoost()
  },
  methods: {
    getBoost () {
      this.spinner(true)
      api
        .getBoostByTierPrize(this.item.id)
        .then(res => {
          this.boostData = res.data.payload
          this.spinner(false)
        })
        .catch(error => {
          this.spinner(false)
          return error
        })
    },
    createBoost () {
      this.spinner(true)
      api
        .createBoost(this.data)
        .then(res => {
          this.data = {}
          this.spinner(false)
          this.getBoost()
          // this.$emit('getPrizing')
          return this.snackbar({ text: 'Boost created successfully' })
        })
        .catch(error => {
          console.log(error)
          this.spinner(false)
          return this.snackbar({ text: error.response.data.msg })
        })
    }
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  }
}
</script>

<style lang="scss" scoped></style>
